module.exports = __webpack_public_path__ + "img/0Q3A2940_L_BlackMatted_MockedUp.231408c1.jpg";